<template>
  <div class="app-page">
    <header class="header">
      <h1>📸 Amazing Photo Pro</h1>
      <p>🎨 Edite suas fotos com facilidade, adicione emojis, stickers exclusivos e animados!</p>
    </header>
    
    <section class="features">
      <h2>✨ Recursos Incríveis</h2>
      <div class="feature-list">
        <div class="feature">
          <h3>🖌️ Edição de Imagens</h3>
          <p>Ajuste brilho, contraste, filtros e muito mais.</p>
        </div>
        <div class="feature">
          <h3>😊 Adicione Emojis</h3>
          <p>Personalize suas fotos com uma variedade de emojis divertidos.</p>
        </div>
        <div class="feature">
          <h3>🎭 Stickers Exclusivos</h3>
          <p>Use stickers animados e únicos para dar um toque especial às suas fotos.</p>
        </div>
      </div>
    </section>
    
    <section class="download-app">
      <h2>📲 Baixe Agora</h2>
      <p>Transforme suas fotos com apenas alguns toques!</p>
      <a href="#" class="google-play">
        <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Baixar no Google Play">
      </a>
    </section>

    <div class="privacy-section">
        <button @click="togglePrivacyPolicy" class="toggle-button">
          {{ showPrivacyPolicy ? 'Ocultar' : 'Mostrar' }} Política de Privacidade
          <span class="arrow" :class="{ 'up': showPrivacyPolicy }">▼</span>
        </button>
        
        <transition name="slide">
        <iframe 
                v-if="showPrivacyPolicy"
                :src="privacyPolicyContent"
                class="privacy-iframe"
                frameborder="0"
            ></iframe>
        </transition>
      </div>


  </div>
</template>



<script>
  export default {
      name: 'AmazingPhotoProPage',
    data() {
      return {
        showPrivacyPolicy: false,
        privacyPolicyContent: `data:text/html;charset=utf-8,${encodeURIComponent(`
        <!DOCTYPE html>
<html lang="pt-br">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Política de Privacidade - Amazing Photo Editor Pro</title>
  <style>
    .privacy-policy {
      font-family: Arial, sans-serif;
      max-width: 800px;
      margin: 0 auto;
      padding: 20px;
    }

    h1 {
      color: #333;
    }

    h2 {
      color: #555;
    }

    a {
      color: #4CAF50;
    }
  </style>
</head>
<body>
  <div class="privacy-policy">
    <h1>Política de Privacidade</h1>
    <p>Bem-vindo à nossa Política de Privacidade. No <strong>Amazing Photo Editor Pro</strong>, respeitamos a sua privacidade e queremos esclarecer que <strong>não coletamos, armazenamos ou compartilhamos quaisquer dados pessoais dos usuários</strong>.</p>

    <h2>Coleta de Informações</h2>
    <p>O <strong>Amazing Photo Editor Pro</strong> não coleta nenhuma informação pessoal, incluindo nome, e-mail ou dados de uso do aplicativo.</p>

    <h2>Compartilhamento de Dados</h2>
    <p>Como não coletamos dados, também não compartilhamos nenhuma informação com terceiros.</p>

    <h2>Links para Terceiros</h2>
    <p>O aplicativo pode conter links para sites externos. Não somos responsáveis pelas políticas de privacidade desses sites.</p>

    <h2>Alterações na Política de Privacidade</h2>
    <p>Se houver qualquer alteração nesta política, atualizaremos esta página para refletir as mudanças.</p>

    <h2>Entre em Contato</h2>
    <p>Se tiver dúvidas sobre esta política, entre em contato pelo e-mail <a href="mailto:aleappdev@gmail.com">aleappdev@gmail.com</a>.</p>
  </div>
</body>
</html>
      `)}`

    
      }
    },
    methods: {
      togglePrivacyPolicy() {
        this.showPrivacyPolicy = !this.showPrivacyPolicy
      }
    }
  };
  </script>

<style scoped>
.app-page {
  text-align: center;
  padding: 20px;
  font-family: Arial, sans-serif;
}
.header {
  background-color: #f4f4f4;
  padding: 20px;
  border-radius: 10px;
}
.features {
  margin: 20px 0;
}
.feature-list {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.feature {
  width: 30%;
  min-width: 250px;
  padding: 10px;
}
.download-app {
  margin-top: 20px;
}
.google-play img {
  width: 150px;
}


.privacy-section {
    margin-top: 30px;
    border-top: 1px solid #eee;
    padding-top: 20px;
  }
  
  .toggle-button {
    background: #4CAF50;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.3s;
  }
  
  .toggle-button:hover {
    background: #45a049;
  }
  
  .arrow {
    display: inline-block;
    transition: transform 0.3s;
    margin-left: 10px;
  }
  
  .arrow.up {
    transform: rotate(180deg);
  }
  
  .privacy-iframe {
    width: 100%;
    height: 500px;
    margin-top: 15px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  

</style>
